import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputFieldComponent } from "./input-field.component";
import { NgZorroAntdModule } from "../../modules/nz-zorro-antd.module";
import { NgZorroIconModule } from "../../modules/nz-icon-antd.module";
import { ReactiveFormsModule } from "@angular/forms";
import { ValidationErrorsModule } from "../validation-errors/validation-errors.module";

@NgModule({
	declarations: [
		InputFieldComponent
	],
	imports: [
		CommonModule,
		NgZorroAntdModule,
		NgZorroIconModule,
		ReactiveFormsModule,
		ValidationErrorsModule
	],
	exports: [
		InputFieldComponent
	]
})

export class InputFieldModule {}
